export function isWarehouseSelectionEnabled (rawData = {}) {
  return rawData?.options?.selectable === true
}

export function createWarehouseSelectionEvent (data) {
  return {
    type: 'Orderadmin\\Storage\\Entity\\Warehouse',
    event: 'storage.warehouse.opened',
    data
  }
}
